export default __webpack_public_path__ + "static/media/location.7d875854.svg";